"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ed25519KeyPairIdentity = void 0;
const node_forge_1 = __importStar(require("node-forge"));
const bip39 = __importStar(require("bip39"));
const cose_1 = require("../../message/cose");
const ed25519 = node_forge_1.pki.ed25519;
const types_1 = require("../types");
class Ed25519KeyPairIdentity extends types_1.PublicKeyIdentity {
    constructor(publicKey, privateKey) {
        super();
        this.publicKey = publicKey;
        this.privateKey = privateKey;
    }
    static getMnemonic() {
        return bip39.generateMnemonic();
    }
    async getAddress() {
        const coseKey = this.getCoseKey();
        return coseKey.toAddress();
    }
    static fromMnemonic(mnemonic) {
        const sanitized = mnemonic.trim().split(/\s+/g).join(" ");
        if (!bip39.validateMnemonic(sanitized)) {
            throw new Error("Invalid Mnemonic");
        }
        const seed = bip39.mnemonicToSeedSync(sanitized).slice(0, 32);
        return Ed25519KeyPairIdentity.fromHex(seed);
    }
    static fromHex(hex) {
        const keys = ed25519.generateKeyPair({ seed: hex });
        return new Ed25519KeyPairIdentity(keys.publicKey, keys.privateKey);
    }
    static fromPem(pem) {
        try {
            const der = node_forge_1.default.pem.decode(pem)[0].body;
            const asn1 = node_forge_1.default.asn1.fromDer(der.toString());
            const { privateKeyBytes } = ed25519.privateKeyFromAsn1(asn1);
            return Ed25519KeyPairIdentity.fromHex(privateKeyBytes);
        }
        catch (e) {
            throw new Error("Invalid PEM");
        }
    }
    async sign(data) {
        return ed25519.sign({
            message: data,
            privateKey: this.privateKey,
        });
    }
    async verify(m) {
        throw new Error("Method not implemented.");
    }
    getCoseKey() {
        const c = new Map();
        c.set(1, 1); // kty: OKP
        c.set(3, -8); // alg: EdDSA
        c.set(-1, 6); // crv: Ed25519
        c.set(4, [2]); // key_ops: [verify]
        c.set(-2, this.publicKey); // x: publicKey
        return new cose_1.CoseKey(c);
    }
    toJSON() {
        return {
            dataType: this.constructor.name,
            publicKey: this.publicKey,
            privateKey: this.privateKey,
        };
    }
}
exports.Ed25519KeyPairIdentity = Ed25519KeyPairIdentity;
